import * as Yup from 'yup';

export const sellerReviewValidator = Yup
  .object()
  .shape({
    message: Yup.string().required('Name is required.'),
    rating: Yup.number().min(0).max(5).required('You must leave a rating.'),
  });

export const reportValidator = Yup
  .object()
  .shape({
    name: Yup.string().nullable(),
    email: Yup.string().email('Email is invalid').nullable(),
    details: Yup.string().required('Please provide some details.').max(6000),
    images: Yup
      .array()
      .of(
        Yup
          .object()
          .shape({
            public_id: Yup.string().nullable(),
            file_url: Yup.string().url().nullable(),
            file_type: Yup.string().nullable(),
            file_name: Yup.string().nullable(),
            size: Yup.number().nullable(),
            created_at: Yup.string().nullable(),
            updated_at: Yup.string().nullable(),
            id: Yup.number().positive().min(1).nullable(),
          }),
      )
      .max(3)
      .nullable(),
  });

export const testimonialValidator = Yup
  .object()
  .shape({
    name: Yup.string().required('Name is required'),
    email: Yup.string().email('Email is invalid').required('Email is required'),
    title: Yup.string().nullable().max(255),
    body: Yup.string().required('Description is required').max(6000),
    breeder_phone: Yup
      .string()
      .nullable()
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        'Please enter a valid, ten digit phone number.',
      ),
    breeder_name: Yup.string().max(80),
    images: Yup
      .array()
      .of(
        Yup
          .object()
          .shape({
            public_id: Yup.string().nullable(),
            file_url: Yup.string().url().nullable(),
            file_type: Yup.string().nullable(),
            file_name: Yup.string().nullable(),
            size: Yup.number().nullable(),
            created_at: Yup.string().nullable(),
            updated_at: Yup.string().nullable(),
            id: Yup.number().positive().min(1).nullable(),
          }),
      )
      .max(3)
      .nullable(),
  });
